import React from "react";
import tracking from "~/Gtm/Tracking/tracking";
import PlusBadge from "~/common/Header/AlertBanner/Logos/PlusBadge";
import Chevron from "~/common/Header/AlertBanner/icons/Chevron";
import usePlusSignupState from "~/common/PlusSubscriptionModal/hooks/usePlusModalData";
import { UserState } from "~/common/Store/models/RootReadonly";

interface Props {
  user: UserState;
  textColorOverride: string;
  shortTextClassNames: string;
  longTextClassNames: string;
  chevronStrokeColor: string;
}

const PlusPromotion = ({
  user,
  textColorOverride,
  shortTextClassNames,
  longTextClassNames,
  chevronStrokeColor,
}: Props) => {
  const { plusSignupState } = usePlusSignupState();
  const freeTrialFlag = plusSignupState?.enrollmentOptions.some(
    (promo) =>
      promo.isPromotion &&
      promo.price === 0 &&
      promo.promotionName === "First month FREE",
  );
  const isFreeTrialAvailable = !user.registered ? true : freeTrialFlag;

  const shortBannerText = isFreeTrialAvailable
    ? "FREE Trial Available!"
    : "Unlock FREE Shipping!";
  const longBannerText = isFreeTrialAvailable
    ? "FREE Trial Available! Unlock Free Shipping"
    : "Unlock Savings with FREE Shipping!";

  return (
    <tracking.a
      data-track="web-plus-global-header"
      data-track-ei={
        isFreeTrialAvailable
          ? "web-plus-global-header-free-trial"
          : "web-plus-global-header-no-free-trial"
      }
      aria-label="Plus"
      href="/plus/"
      className="inline-flex items-center font-semibold text-xs text-gray-800 hover:underline no-underline"
      style={textColorOverride ? { color: textColorOverride } : {}}
      data-testid="plus-banner"
    >
      <PlusBadge classNames="pr-2" />
      <span className={shortTextClassNames} data-testid="plus-short-text">
        {shortBannerText}
      </span>
      <span className={longTextClassNames} data-testid="plus-long-text">
        {longBannerText}
      </span>
      <Chevron strokeColor={chevronStrokeColor} classNames="pl-2" />
    </tracking.a>
  );
};

export default PlusPromotion;
